import Eos from 'eosjs'

export default {
  namespaced: true,
  state: {
    scatter: null,
    scatterInstalled: true,
    publicKey: '',
    authority: '',
    accountName: ''
  },
  getters: {
    scatter: state => state.scatter,
    scatterInstalled: state => state.scatterInstalled,
    account: state => {
      if (state.scatter) {
        return state.scatter.identity.accounts
          .find(x => x.blockchain === 'eos')
      } else {
        return null
      }
    },
    accounts: state => {
      if (state.scatter && state.scatter.identity) {
        return state.scatter.identity.accounts
          .filter(x => x.blockchain === 'eos')
      } else {
        return []
      }
    }
  },
  mutations: {
    setScatter (state, scatter) {
      state.scatter = scatter
    },
    setScatterInstalled (state, installed) {
      state.scatterInstalled = installed
    },
    setPublicKey (state, publicKey) {
      state.publicKey = publicKey
    },
    setAuthority (state, authority) {
      state.authority = authority
    },
    setAccountName (state, accountName) {
      state.accountName = accountName
    }
  },
  actions: {
    setScatter ({ commit }, scatter) {
      commit('setScatter', scatter)
    },
    setScatterInstalled ({ commit }, installed) {
      commit('setScatterInstalled', installed)
    },
    async forgetIdentity ({ state }) {
      if (state.scatter) {
        await state.scatter.forgetIdentity()
      }
    },
    async getCredentials ({ commit, state, dispatch, getters }) {
      if (!state.scatter) { return }

      const network = {
        blockchain: 'eos',
        protocol: 'https',
        host: 'nodes.get-scatter.com',
        port: 443,
        chainId: 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906'
      }

      await state.scatter.getIdentity({
        accounts: [network]
      })

      const account = getters.account

      const accountName = account.name
      const authority = account.authority
      commit('setAccountName', accountName)
      commit('setAuthority', authority)

      if (!account.publicKey) {
        const eosOptions = { expireInSeconds: 60 }
        const eos = state.scatter.eos(network, Eos, eosOptions)
        const acc = await eos.getAccount(account.name)
        const permission = acc.permissions.filter((perm) => {
          return perm.perm_name === authority
        })[0]
        const publicKey = permission.required_auth.keys[0].key
        commit('setPublicKey', publicKey)
      } else {
        const publicKey = account.publicKey
        commit('setPublicKey', publicKey)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/scatter.js